// src/reducers/favouritesReducer.js

import {
    GET_ALL_FAVOURITES_REQUEST,
    GET_ALL_FAVOURITES_SUCCESS,
    GET_ALL_FAVOURITES_FAIL,
    ADD_FAVOURITE_REQUEST,
    ADD_FAVOURITE_SUCCESS,
    ADD_FAVOURITE_FAIL,
    UPDATE_FAVOURITE_REQUEST,
    UPDATE_FAVOURITE_SUCCESS,
    UPDATE_FAVOURITE_FAIL,
    DELETE_FAVOURITE_REQUEST,
    DELETE_FAVOURITE_SUCCESS,
    DELETE_FAVOURITE_FAIL,
  } from '../actions/types';
  
  const initialState = {
    favourites: [],
    loading: false,
    error: null,
  };
  
  export default function(state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      // --- REQUESTS (sets loading to true) ---
      case GET_ALL_FAVOURITES_REQUEST:
      case ADD_FAVOURITE_REQUEST:
      case UPDATE_FAVOURITE_REQUEST:
      case DELETE_FAVOURITE_REQUEST:
        return { ...state, loading: true, error: null };
  
      // --- FAILURES (sets error message) ---
      case GET_ALL_FAVOURITES_FAIL:
      case ADD_FAVOURITE_FAIL:
      case UPDATE_FAVOURITE_FAIL:
      case DELETE_FAVOURITE_FAIL:
        return { ...state, loading: false, error: payload };
  
      // --- SUCCESSES (updates the state data) ---
      case GET_ALL_FAVOURITES_SUCCESS:
        return {
          ...state,
          loading: false,
          favourites: payload,
        };
        
      case ADD_FAVOURITE_SUCCESS:
        return {
          ...state,
          loading: false,
          favourites: [...state.favourites, payload], // Add the new favourite to the array
        };
  
      case UPDATE_FAVOURITE_SUCCESS:
        return {
          ...state,
          loading: false,
          // Find the favourite by ID and replace it with the updated version
          favourites: state.favourites.map(fav => 
            fav.id === payload.id ? payload : fav
          ),
        };
  
      case DELETE_FAVOURITE_SUCCESS:
        return {
          ...state,
          loading: false,
          // Filter out the favourite with the matching ID
          favourites: state.favourites.filter(fav => fav.id !== payload),
        };
  
      default:
        return state;
    }
  }